import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { TableDefault } from '../../../../components';
import { updateDmService } from '../../../../services/Api';
import mainActions from "../../../../redux/modules/main";

class Items extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      page: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Nome',
      actions: [],
      order: '',
      // urlDelete: '/Usuario/',
      urlEdit: '/admin/usuario/',
      urlLoad: '/Usuario/GetListagem',
    };
  }

  static propTypes = {
    defaultFilters: PropTypes.string,
  };

  static defaultProps = {
    defaultFilters: '',
  };

  componentWillMount = () => {
    const { defaultFilters, loadBadgets } = this.props;
    const aprovar = {
      modalHeading: 'Aprovar Usuário',
      modalMessage: 'Deseja aprovar este usuário?',
      icon: 'check_circle',
      errorMessage: 'Não foi possível liberar o usuário',
      successMessage: 'Usuário aprovado com sucesso',
      action: async id => {
        await updateDmService('Usuario/AlteraStatus/', id, { status: 1 });
        loadBadgets();
      },
    };
    const bloquear = {
      modalHeading: 'Bloquear Usuário',
      modalMessage: 'Você tem certeza que deseja bloquear este usuário?',
      icon: 'not_interested',
      errorMessage: 'Não foi possível bloquear o usuário',
      successMessage: 'Usuário bloqueado com sucesso',
      action: async id => {
        await updateDmService('Usuario/AlteraStatus', id, { status: 2 });
        loadBadgets();
      },
    };
    const desbloquear = {
      modalHeading: 'Desbloquar Usuário',
      modalMessage: 'Você tem certeza que deseja desbloquear este usuário?',
      icon: 'check_circle',
      errorMessage: 'Não foi possível desbloquear o usuário',
      successMessage: 'Usuário desbloqueado com sucesso',
      action: async id => {
        await updateDmService('Usuario/AlteraStatus/', id, { status: 1 });
      },
    };

    if (defaultFilters === 'status=3') {
      this.setState({ actions: [aprovar, bloquear] });
    } else if (defaultFilters === 'status=2') {
      this.setState({ actions: [desbloquear] });
    } else if (defaultFilters === 'status=1') {
      this.setState({ actions: [bloquear] });
    } else if (defaultFilters ==='status=0'){
      this.setState({ actions: [aprovar, bloquear] });
    }
  };

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlEdit,
      urlLoad,
      actions,
    } = this.state;

    const { type, defaultFilters } = this.props;
    return (
      <div className="user-list">
        <TableDefault
          search={search}
          type={type}
          order={order}
          orderBy={orderBy}
          defaultFilters={defaultFilters}
          extraRows={actions}
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          // urlDelete={urlDelete}
          urlEdit={urlEdit}
          urlLoad={urlLoad}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  badgets: state.main.badgets
});

const mapDispatchToProps = dispatch => ({
  loadBadgets() {
    return dispatch(mainActions.receiveBadget());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Items);



// WEBPACK FOOTER //
// ./src/screens/admin/Users/List/Items.js